// extracted by mini-css-extract-plugin
module.exports = {"badge":"TooltipBadge_badge__2MFBz","badgeIconV2":"TooltipBadge_badgeIconV2__fmYN4"};